import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Divider, Link, ListItemIcon, ListItemText, MenuItem, MenuList, Typography } from '@mui/material';
import {
    AccountTree,
    BugReport,
    Domain,
    EmojiEmotions,
    Extension,
    FolderCopy,
    Grading,
    Groups,
    Home,
    Hub,
    Label,
    Landscape,
    PermMedia,
    PhotoLibrary,
    ReceiptLong,
    SafetyCheck,
    SmartToy,
    ViewInAr,
} from '@mui/icons-material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';

type AdminMenuProps = {
    toggleDrawer?: () => void;
};

const AdminMenu: FC<AdminMenuProps> = ({ toggleDrawer }) => {
    const { classes } = useStyles();
    const location = useLocation();

    return (
        <div className={classes.navContainer}>
            <MenuList className={classes.menuList}>
                <MenuItem className={classes.topItem} selected={location.pathname === '/admin'}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin'}>
                        <ListItemIcon>
                            <Home />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Dashboard</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        target={'_blank'}
                        to={`https://${import.meta.env.PROD ? import.meta.env.VITE_URI : 'intract.dev'}/mission/horizon`}
                    >
                        <ListItemIcon>
                            <Hub />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Queues</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        target={'_blank'}
                        to={`https://${
                            import.meta.env.PROD ? import.meta.env.VITE_URI : 'intract.dev'
                        }/mission/telescope`}
                    >
                        <ListItemIcon>
                            <BugReport />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Debugger</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <Divider component={'li'} variant={'middle'} />
                <MenuItem selected={location.pathname.includes('/admin/audits')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/audits'}>
                        <ListItemIcon>
                            <ReceiptLong />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Audit Logs</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/folders')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/folders'}>
                        <ListItemIcon>
                            <FolderCopy />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Folders</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/hdris')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/hdris'}>
                        <ListItemIcon>
                            <Landscape />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>HDRIs</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/images')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/images'}>
                        <ListItemIcon>
                            <PhotoLibrary />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Images</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/intract-models')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/intract-models'}
                    >
                        <ListItemIcon>
                            <ViewInAr />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Intract Models</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/intract-plugins')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/intract-plugins'}
                    >
                        <ListItemIcon>
                            <Extension />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Intract Plugins</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/media')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/media'}>
                        <ListItemIcon>
                            <PermMedia />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Media</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/models')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/models'}>
                        <ListItemIcon>
                            <ViewInAr />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Models</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/organizations')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/organizations'}
                    >
                        <ListItemIcon>
                            <Domain />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Organizations</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/projects')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/projects'}>
                        <ListItemIcon>
                            <AccountTree />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Projects</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/reviews')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/reviews'}>
                        <ListItemIcon>
                            <Grading />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Reviews</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/roblox-avatar-decks')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/roblox-avatar-decks'}
                    >
                        <ListItemIcon>
                            <EmojiEmotions />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Roblox Avatar Decks</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/tags')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/tags'}>
                        <ListItemIcon>
                            <Label />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Tags</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/users')}>
                    <Link onClick={toggleDrawer} className={classes.link} component={RouterLink} to={'/admin/users'}>
                        <ListItemIcon>
                            <Groups />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>Users</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/ai-images')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/ai-images'}
                    >
                        <ListItemIcon>
                            <SmartToy />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>User A.I. Images</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/user-images')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/user-images'}
                    >
                        <ListItemIcon>
                            <PhotoLibrary />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>User Images</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/user-folders')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/user-folders'}
                    >
                        <ListItemIcon>
                            <FolderCopy />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>User Folders</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/user-logins')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/user-logins'}
                    >
                        <ListItemIcon>
                            <SafetyCheck />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>User Logins</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
                <MenuItem selected={location.pathname.includes('/admin/user-models')}>
                    <Link
                        onClick={toggleDrawer}
                        className={classes.link}
                        component={RouterLink}
                        to={'/admin/user-models'}
                    >
                        <ListItemIcon>
                            <ViewInAr />
                        </ListItemIcon>
                        <ListItemText>
                            <Typography variant={'subtitle1'}>User Models</Typography>
                        </ListItemText>
                    </Link>
                </MenuItem>
            </MenuList>
        </div>
    );
};

const useStyles = makeStyles()((theme) => ({
    link: {
        color: theme.palette.text.primary,
        textDecoration: 'none',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    navContainer: {
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 0,
            display: 'none',
        },
        scrollbarWidth: 'none',
    },
    menuList: {
        paddingTop: 0,
        '& .MuiMenuItem-root': {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
        },
    },
    topItem: {
        borderTopRightRadius: theme.spacing(1),
    },
}));

export default AdminMenu;
